<template>
  <div class="mt-md-0 mt-2">
    <div class="details-title">{{ title }}</div>

    <div v-if="hideInvoiceData" class="row different-invoice-address">
      <div class="col-md-13">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="invoice_differs_from_delivery" value="" name="invoice-differs-from-delivery" id="invoice-differs-from-delivery">
          <label class="form-check-label" for="invoice-differs-from-delivery">
            Factuuradres is anders dan afleveradres
          </label>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card card-body card-account bg-light">
        <div class="row">
          <div class="col-md-8">
            <p>
              {{ accountData.invoice_address }}
              {{ accountData.invoice_postcode }}
              {{ accountData.invoice_city }}
            </p>
          </div>
          <div class="col-md-5 text-right">
            <div @click="$bvModal.show('invoice-details-modal')" class="link">Wijzig</div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="invoice-details-modal" id="invoice-details-modal" footer-class="modal-footer modal-save-details" size="sm" centered>
      <template slot="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <form @submit.prevent="onSubmit">
            <div class="form-row">
              <div class="col-md-13">
                <label for="invoice_address" class="col-form-label">Adres</label>
                <input
                  id="invoice_address"
                  name="invoice_address"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.invoice_address.$error}"
                  v-model="invoice_address"
                  @blur="$v.invoice_address.$touch()"
                  placeholder="Adres"
                >
                <span v-if="$v.invoice_address.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. het adres in.</strong>
                </span>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-5">
                <label for="invoice_postcode" class="col-form-label">Postcode</label>
                <input
                  id="invoice_postcode"
                  name="invoice_postcode"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.invoice_postcode.$error}"
                  v-model="invoice_postcode"
                  @blur="$v.invoice_postcode.$touch()"
                  placeholder="1324AB"
                >
                <span v-if="$v.invoice_postcode.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. de postcode in.</strong>
                </span>
              </div>
              <div class="col-md-8">
                <label for="invoice_city" class="col-form-label">Plaats</label>
                <input
                  id="invoice_city"
                  name="invoice_city"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.invoice_city.$error}"
                  v-model="invoice_city"
                  @blur="$v.invoice_city.$touch()"
                  placeholder="Plaats"
                >
                <span v-if="$v.invoice_city.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. de plaats in.</strong>
                </span>
              </div>
            </div>
          </form>
        </div>

        <div
          v-if="invoiceDetailsStatus"
          class="col-md-13 mt-2 alert"
          role="alert"
          :class="{ 'alert-success': invoiceDetailsStatus.success, 'alert-danger': !invoiceDetailsStatus.success }"
        >
          <strong>{{ invoiceDetailsStatus.message }}</strong>
        </div>
      </template>
      <template slot="modal-footer">
        <div>
          <button
            @click="copyDeliveryAddress"
            type="button"
            class="btn btn-outline-oldevuuren w-100 btn-round mb-3">Afleveradres overnemen
          </button>
          <button
            @click="saveDetails"
            type="button"
            :disabled="$v.$invalid"
            :class="{'disabled cursor-not-allowed': $v.$invalid}"
            class="btn btn-oldevuuren btn-round w-100">Opslaan
            <font-awesome-icon class="font-awesome-icon" v-if="invoiceDetailsBusy" icon="spinner" spin/>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { minLength, required } from 'vuelidate/lib/validators'

  import { MUTATE_INVOICE_DETAILS_STATUS, SAVE_INVOICE_DETAILS } from '../../../store/types'

  export default {
    props: ['accountData'],
    data() {
      return {
        title: 'Factuuradres',
        invoice_address: this.accountData.invoice_address,
        invoice_postcode: this.accountData.invoice_postcode,
        invoice_city: this.accountData.invoice_city,
        invoice_differs_from_delivery: false
      }
    },
    validations: {
      invoice_address: {
        required,
        minLen: minLength(2)
      },
      invoice_postcode: {
        required,
        minLen: minLength(6)
      },
      invoice_city: {
        required,
        minLen: minLength(6)
      }
    },
    computed: {
      invoiceDetailsStatus() {
        return this.$store.getters.invoiceDetailsStatus
      },
      invoiceDetailsBusy() {
        return this.$store.getters.invoiceDetailsBusy
      },
      hideInvoiceData() {
        if (this.accountData.invoice_equals_delivery) {
          return !this.invoice_differs_from_delivery
        }

        return false
      }
    },
    watch: {
      invoice_differs_from_delivery(val) {
        if (val) {
          this.$refs['invoice-details-modal'].show()
        }
      }
    },
    methods: {
      hideModal() {
        // hide
        this.$refs['invoice-details-modal'].hide()
        // discard changes
        this.invoice_address = this.accountData.invoice_address
        this.invoice_postcode = this.accountData.invoice_postcode
        this.invoice_city = this.accountData.invoice_city
      },
      copyDeliveryAddress() {
        this.invoice_address = this.accountData.address
        this.invoice_postcode = this.accountData.postcode
        this.invoice_city = this.accountData.city
      },
      saveDetails() {
        const formData = {
          invoice_address: this.invoice_address,
          invoice_postcode: this.invoice_postcode,
          invoice_city: this.invoice_city
        }
        this.$store.dispatch(SAVE_INVOICE_DETAILS, formData).then(() => {
          if (this.invoiceDetailsStatus.success) {
            this.$refs['invoice-details-modal'].hide()
          }
        })
      }
    },
    mounted() {
      const store = this.$store
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        store.commit(MUTATE_INVOICE_DETAILS_STATUS, null)
      })
    }
  }
</script>

<style lang="scss" scoped>
  .different-invoice-address {
    font-size: 1.2em;
    color: $dark-grey;
  }
</style>
